import { msg } from '@lingui/core/macro';
import { OldSubCategoryType } from '@/@types';

const restaurantsFilters = [
  {
    id: '82',
    title: msg`Asian`,
    name: 'Asian',
  },
  {
    id: '135',
    title: msg`Pub`,
    name: 'Pub',
  },
  {
    id: '86',
    title: msg`Burguer`,
    name: 'Burguer',
  },
  {
    id: '42',
    title: msg`Coffee shop`,
    name: 'Coffee shop',
  },
  {
    id: '88',
    title: msg`Original`,
    name: 'Original',
  },
  {
    id: '8',
    title: msg`Meat`,
    name: 'Meat',
  },
  {
    id: '84',
    title: msg`Market`,
    name: 'Market',
  },
  {
    id: '70',
    title: msg`Snacks`,
    name: 'Snacks',
  },
  {
    id: '83',
    title: msg`Healthy`,
    name: 'Healthy',
  },
  {
    id: '85',
    title: msg`Hindu`,
    name: 'Hindu',
  },
  {
    id: '66',
    title: msg`Italian`,
    name: 'Italian',
  },
  {
    id: '67',
    title: msg`Japanese`,
    name: 'Japanese',
  },
  {
    id: '72',
    title: msg`Others`,
    name: 'Others',
  },
  {
    id: '87',
    title: msg`Seafood`,
    name: 'Seafood',
  },
  {
    id: '89',
    title: msg`Mexican`,
    name: 'Mexican',
  },
] as OldSubCategoryType[];

export default restaurantsFilters;
